module.exports = __webpack_public_path__ + "static/media/fireworks.8911ed0e.svg";